
import React from 'react';
import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/homepage/Hero';
import { StatisticsSection } from '@/components/homepage/StatisticsSection';
import { UrgencySection } from '@/components/homepage/UrgencySection';
import { HowItWorksSection } from '@/components/homepage/HowItWorksSection';
import { FeaturesSection } from '@/components/homepage/FeaturesSection';
import { PremiumSection } from '@/components/homepage/PremiumSection';
import { CTASection } from '@/components/homepage/CTASection';
import { TrustSection } from '@/components/homepage/TrustSection';
import { EmergencyTypesSection } from '@/components/homepage/EmergencyTypesSection';
import { TestimonialsSection } from '@/components/homepage/TestimonialsSection';
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <StatisticsSection />
      <UrgencySection />
      <HowItWorksSection />
      <FeaturesSection />
      <TestimonialsSection />
      <PremiumSection />
      <CTASection />
      <TrustSection />
      <EmergencyTypesSection />
      <Footer />
    </div>
  );
};

export default Index;
